import { Box, Flex, Text, Tooltip, VisuallyHidden } from '@chakra-ui/react';
import React, { useId } from 'react';

import type { EvidenceSpanRef } from '../../interface/codes';
import { ADD_CODE_DIALOG as D, CODE_ACTION_INERT_OPACITY, INK_MUTED, INK_SOFT, SURFACE_WARM, TX_LABEL_COLOR } from '../../styles/tokens';
import { AtomButton } from './AtomButton';

const noop = (): void => {};
const LATER_RELEASE = 'Picking a span from the document will be added in a later release';
const INERT_PICK = {
  '& > button[aria-disabled="true"], & > button[aria-disabled="true"]:hover, & > button[aria-disabled="true"]:active': {
    color: INK_MUTED,
    borderColor: INK_MUTED,
    backgroundColor: 'transparent',
    opacity: CODE_ACTION_INERT_OPACITY,
    cursor: 'not-allowed'
  }
};

export type EvidenceSpanSectionProps = {
  readonly spans?: readonly EvidenceSpanRef[];
  readonly activeNoteLabel?: string;
};

export const EvidenceSpanSection: React.FC<EvidenceSpanSectionProps> = ({
  spans = [],
  activeNoteLabel
}) => {
  const hintId = useId();

  return (
    <Box mt={D.sectionGap}>
      <Text fontSize={D.labelSize} fontWeight={D.labelWeight} letterSpacing={D.labelSpacing} color={TX_LABEL_COLOR} mb={D.labelGap}>
        EVIDENCE SPAN
        {activeNoteLabel && (
          <Text as="span" fontSize="12px" fontWeight={500} color={INK_MUTED}>
            {' '}
            · {activeNoteLabel}
          </Text>
        )}
      </Text>
      {spans.length > 0 ? (
        <Box borderWidth="1px" borderColor={D.rule} borderRadius={D.controlRadius} px="12px" py="10px">
          {spans.map((span) => (
            <Text key={span.id}>{span.text}</Text>
          ))}
        </Box>
      ) : (
        <Flex borderWidth="1px" borderStyle="dashed" borderColor={D.rule} borderRadius={D.controlRadius} px="12px" py="10px" bg={SURFACE_WARM} gap="12px" align="center">
          <Box flex="1">
            <Text fontSize="12.5px" fontWeight={600} color={INK_SOFT}>No span attached</Text>
            <Text fontSize="12px" lineHeight="18px" color={TX_LABEL_COLOR}>
              Attach a passage as justification for this code (recommended). You can attach multiple
              spans as supporting evidence.
            </Text>
          </Box>
          <Tooltip label={LATER_RELEASE} placement="top" openDelay={300}>
            <Box as="span" display="inline-flex" sx={INERT_PICK}>
              <AtomButton className="btn-secondary" aria-disabled="true" aria-describedby={hintId} onClick={noop}>
                Pick span from doc
              </AtomButton>
              <VisuallyHidden id={hintId}>{LATER_RELEASE}</VisuallyHidden>
            </Box>
          </Tooltip>
        </Flex>
      )}
    </Box>
  );
};
